module.exports = __webpack_public_path__ + "img/Frame 133.80ee77a0.png";